export { default } from './PostfixIconWrapper';
